
const sideBar = () => {

    const menus = [
        {
            id: 'Home',
            route: '/',
            title: '',
            icon: 'mdi-home',
            order: 1
        },
        {
            id: 'ViewTasks',
            route: 'tasks',
            title: 'Tasks',
            icon: 'mdi-clipboard-account',
            active : false,
            order: 2
        },
        {
            id: 'MySubmissions',
            route: 'my-submissions',
            title: 'MySubmissions',
            icon: 'mdi-content-save-check',
            order: 3
        },
        {
            id: 'Procedures',
            title: 'Procedures',
            icon: 'mdi-clipboard-list-outline',
            order: 4,
            children: [
                // route param is named workflowId but InitiateProcess uses it as processTypeId (ProcessType.Id)
                { id: 'Svc_InternalSurveys',        route: 'request-execute-survey', title: 'Svc_InternalSurveys' },
                { id: 'Svc_Inquiry',                route: 'request-inquiry', title: 'Svc_Inquiry' },
                { id: 'Svc_StrategicSatisfaction',  route: 'request-strategic-satisfaction', title: 'Svc_StrategicSatisfaction' },
                { id: 'Svc_OperationalIndicator',   route: 'request-operational-indicator', title: 'Svc_OperationalIndicator' },
                { id: 'Svc_AdditionalAnalysis',     route: 'request-additional-analysis', title: 'Svc_AdditionalAnalysis' },
                { id: 'Svc_ScientificConsultation', route: 'request-scientific-consultation', title: 'Svc_ScientificConsultation' },
                { id: 'Svc_FocusGroups',            route: 'request-focus-groups', title: 'Svc_FocusGroups' },
            ]
        },
        {
            id: 'AddSurvey',
            route: 'add-survey',
            title: 'AddSurvey',
            icon: 'mdi-file-document-plus',
            order: 5
        },
        {
            id: 'SurveyList',
            route: 'survey-list',
            title: 'SurveyList',
            icon: 'mdi-clipboard-check',
            order: 6
        },
        {
            id: 'SurveyListShared',
            route: 'survey-listShared',
            title: 'SurveyListShared',
            icon: 'mdi-clipboard-check',
            order: 7
        },
        {
            id: 'ProcessFollowup',
            route: 'followup',
            title: 'ProcessFollowup',
            icon: 'mdi-refresh-circle',
            order: 8
        },
        {
            id: 'Analytics',
            route: 'analytics',
            title: 'Analytics',
            icon: 'mdi-chart-areaspline',
            order: 9
        },
        /*{
            id: 'ExecutiveAnalytics',
            route: 'executive-analytics',
            title: 'ExecutiveAnalytics',
            icon: 'mdi-chart-areaspline',
        },*/
        {
            id: 'Case',
            title: 'Case',
            icon: 'mdi-sitemap',
            order: 10,
            children: [
                {
                    id: 'WorkflowDesigner',
                    route: 'workflow-designer',
                    title: 'WorkflowDesigner'
                },
                {
                    id: 'Apps',
                    route: 'apps',
                    title: 'Apps'
                }
            ]
        },
        {
            id: 'ManageELibrary',
            route: 'manage-eLibrary',
            title: 'ManageELibrary',
            order: 11
        },

        {
            id: 'SystemAdmin',
            title: 'SystemAdmin',
            icon: 'mdi-cog',
            order: 12,
            children: [
                {
                    id: 'ManageOrganization',
                    route: 'manage-organization',
                    title: 'ManageOrganization'
                },
                {
                    id: 'SystemSettings',
                    route: 'system-settings',
                    title: 'SystemSettings'
                },
                /*{
                    id: 'ELibraryCategories',
                    route: 'eLibrary-categories',
                    title: 'ELibraryCategories'
                },*/

                {
                    id: 'Dictionary',
                    route: 'dictionary',
                    title: 'Dictionary'
                },
                {
                    id: 'oldData',
                    route: 'oldData',
                    title: 'OldChartData'
                },
                {
                    id: 'municipalitiesData',
                    route: 'municipalitiesData',
                    title: 'MunicipalitiesData'
                },
                {
                    id: 'Lookups',
                    route: 'lookups',
                    title: 'lookups'
                },
                {
                    id: 'Roles',
                    route: 'roles',
                    title: 'Roles'
                },
                {
                    id: 'QuestionDropDown',
                    route: 'QuestionDropDown',
                    title: 'QuestionDropDown'
                },
                {
                    id: 'QuestionsBank',
                    route: 'QuestionsBank',
                    title: 'QuestionsBank'
                },
                {
                    id: 'EmailTemplates',
                    route: 'EmailTemplates',
                    title: 'EmailTemplates'
                },
                {
                    id: 'AuditTrail',
                    route: 'audit-trail',
                    title: 'AuditTrail'
                },
                {
                    id: 'Municipalities',
                    route: 'Municipalities',
                    title: 'Municipalities'
                },
                {
                    id: 'LocationManagement',
                    route: 'location-management',
                    title: 'LocationManagement'
                },
                {
                    id: 'EmailAuditList',
                    route: 'EmailAuditList',
                    title: 'EmailAuditList'
                }
            ]
        },
    ]



    return menus

}

export default sideBar
